import { isDefined } from '@sgme/fp';
import { guidedTourConnector } from 'apiConnector/guided-tour';
import { useCallback, useState } from 'react';
import { lastValueFrom } from 'rxjs';
import { httpClient } from 'utils/http/httpClient';

export const guidedTourApi = guidedTourConnector(httpClient);

export function useTourSteps() {
  const [stepIds, setStepIds] = useState<string[]>([]);

  const refreshTourSteps = useCallback(() => {
    return lastValueFrom(guidedTourApi.loadCompletedSteps()).then(completedSteps => {
      const newStepIds = Array.from(document.querySelectorAll('[data-tour]'))
        .map(node => node.getAttribute('data-tour'))
        .filter(stepId => isDefined(stepId) && !completedSteps?.includes(stepId)) as string[];

      if (stepIds.length !== newStepIds.length || newStepIds.some(newStepId => !stepIds.includes(newStepId))) {
        setStepIds(newStepIds);
      }
    });
  }, [stepIds]);
  return { stepIds, refreshTourSteps };
}
